/** Opens a project's Valuations tab from a Home row, through the shell's app:navigate bridge. */
import type { Project } from '../../types/database';

export function openProjectValuations(projectId: string, projects: readonly Pick<Project, 'id' | 'name'>[]): void {
  const project = projects.find((p) => p.id === projectId);
  window.dispatchEvent(
    new CustomEvent('app:navigate', {
      detail: { view: 'project-detail', projectId, projectName: project?.name ?? '', projectTab: 'interim' },
    }),
  );
}
